import { Navbar, Nav, Container } from "react-bootstrap-v5";
import { NavLink } from "react-router-dom";
import "./NavBar.css"; // Import custom CSS

const NavBar = () => {
  return (
    <Navbar bg="light" expand="lg" className="mynav">
      <Container>
        <Navbar.Brand href="/">DHF Admin</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <NavLink to="/websiteleads" className="nav-link" activeClassName="custom-active">
              Website leads
            </NavLink>
            <NavLink to="/infocallleads" className="nav-link" activeClassName="custom-active">
              Info Call leads
            </NavLink>
            <NavLink to="/search" className="nav-link" activeClassName="custom-active">
              Clients
            </NavLink>
            <NavLink to="/report" className="nav-link" activeClassName="custom-active">
              Report
            </NavLink>
            <NavLink to="/dashboard" className="nav-link" activeClassName="custom-active">
              Dashboard
            </NavLink>
          </Nav>
          <Nav className="ms-auto">
            <NavLink to="/logout" className="nav-link" activeClassName="custom-active">
              Logout
            </NavLink>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
